<div class="cat-modal">
    <div class="cat-modal__header">
        <h3>Add category</h3>
        <button type="button" class="cat-modal__close" (click)="activeModal.dismiss()" aria-label="Close">&times;</button>
    </div>

    <form class="cat-modal__body" (ngSubmit)="save()">
        <label class="field">
            <span>Category name</span>
            <input ngbAutofocus type="text" name="categoryName" [(ngModel)]="categoryName" autocomplete="off" required />
        </label>
        <button type="submit" class="cat-modal__submit" [disabled]="!categoryName.trim()">Save</button>
    </form>
</div>
